import { FC } from 'react';
import { useSiteAssets } from '../hooks/useSiteAssets';

/**
 * BrandMark — ヘッダーのブランドマーク（画像スロット: logo）
 *
 * Admin登録ロゴ（読み込み確認済み）があれば画像を表示し、
 * 未登録時は既定デザイン＝3役色のコニックグラデーション（3役対等の象徴）。
 * 装飾のため alt は空（隣に「ANOKOE」のテキストがある）。
 */
export const BrandMark: FC<{ size?: number }> = ({ size = 28 }) => {
    const { logo } = useSiteAssets();

    if (logo) {
        return (
            <img
                src={logo}
                alt=""
                aria-hidden
                className="rounded-pop-sm object-cover flex-shrink-0"
                style={{ width: size, height: size }}
            />
        );
    }

    return (
        <span
            aria-hidden
            className="inline-flex items-center justify-center rounded-pop-sm flex-shrink-0"
            style={{
                width: size,
                height: size,
                background: 'conic-gradient(from 210deg, #f59e0b, #8b5cf6, #06b6a4, #f59e0b)',
                boxShadow: '0 1px 2px rgba(80,60,90,0.2)',
            }}
        >
            <span className="w-3 h-3 rounded-full bg-surface" />
        </span>
    );
};
